/* External */
import { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import Loading from '@dtvgo/loading';

const TRANSITION_TIME_MS = 300;

function LoaderRipple({ className, shown }) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    let timeout;
    if (shown) {
      setIsVisible(true);
    } else {
      timeout = setTimeout(() => {
        setIsVisible(false);
      }, TRANSITION_TIME_MS);
    }
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [shown]);

  return isVisible && <Loading className={`dtv-html5-c-loader-ripple ${className}`} />;
}

LoaderRipple.propTypes = {
  className: PropTypes.string,
  shown: PropTypes.bool,
};

LoaderRipple.defaultProps = {
  className: '',
  shown: false,
};

export default memo(LoaderRipple);
